module.exports = __webpack_public_path__ + "webfonts/398F09_0_0.eot";


//////////////////
// WEBPACK FOOTER
// ./src/webfonts/398F09_0_0.eot
// module id = 53
// module chunks = 0